import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=9bfd0c96&scoped=true&"
import script from "./Supervisor.vue?vue&type=script&lang=js&"
export * from "./Supervisor.vue?vue&type=script&lang=js&"
import style0 from "./Supervisor.vue?vue&type=style&index=0&id=9bfd0c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfd0c96",
  null
  
)

export default component.exports